module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/app-down-bg-8f9253e0f4b747c968b5d14eb2f116bd.png";